"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.Bar = function (_a) {
    var children = _a.children, boxed = _a.boxed;
    return (react_1.default.createElement("div", { style: {
            background: "#fff",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "70px",
            zIndex: 1000,
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)"
        } },
        react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                maxWidth: boxed ? "1024px" : "100%",
                margin: "auto"
            } }, children)));
};
